import { Alert, AlertActions, AlertDescription, AlertTitle, Button } from '@opaz/ui-components';
import { Container } from './container';
import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const GenericAppError = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Container>
      <Alert variant="destructive">
        <AlertTitle>{t('form.error.general.title')}</AlertTitle>
        <AlertDescription>{t('form.error.general.description')}</AlertDescription>

        <AlertActions>
          <Button variant="secondary" onClick={() => router.history.back()}>
            {t('common.back')}
          </Button>
        </AlertActions>
      </Alert>
    </Container>
  );
};
